import React from 'react';
import { IAuctionMappings } from 'src/pages/CatalogPage/Catalog.i';
import { RadioOption, Typography } from '@riac/design-system';
interface IFilterOption {
  option: {
    name: string,
    slug: string,
    value: string,
  };
  setFilter?(slug: string, field: keyof IAuctionMappings): void;
  count?: number;
}

export const FilterOption = (props: IFilterOption) => {
  const { name, value, slug } = props.option;
  const disabled = props.count < 1 && value !== 'All' ? true : false;
  return (
    <RadioOption
      value={slug}
      isDisabled={disabled}
    >
      <Typography className='text-base leading-6 align-middle text-text' weight='inherit'>
        {name}
        {value !== 'All' && <>&nbsp;<Typography size='xs' weight='regular' color='text-lighter' className='inline'>({props.count})</Typography></>}
      </Typography>
    </RadioOption>
  );
};
